import { render, staticRenderFns } from "./BodyAnatomyTypeAdd.vue?vue&type=template&id=55f5f2fb&scoped=true&"
import script from "./BodyAnatomyTypeAdd.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5f2fb",
  null
  
)

export default component.exports